import { render, staticRenderFns } from "./vue-collapsible.vue?vue&type=template&id=6d4f2672"
import script from "./vue-collapsible.vue?vue&type=script&lang=js"
export * from "./vue-collapsible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/binhdoan/Work/Dev-gits/Shopify-KL/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d4f2672')) {
      api.createRecord('6d4f2672', component.options)
    } else {
      api.reload('6d4f2672', component.options)
    }
    module.hot.accept("./vue-collapsible.vue?vue&type=template&id=6d4f2672", function () {
      api.rerender('6d4f2672', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/vue-collapsible.vue"
export default component.exports